import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ProductsProvider from '../../providers/ProductsProvider';
import ProductItems from '../../components/ProductItems';
import { useHelmet } from '../../../common';
import { useCatalog } from '../../../common/sagas';

const Products = () => {
  const { t } = useTranslation();
  const { loadWorldCatalog, loadGazeCatalog } = useCatalog();

  useHelmet({
    title: t`Products`,
    description: t`Buy the latest clothes trends`
  });

  useEffect(() => {
    loadWorldCatalog();
    loadGazeCatalog();
    // eslint-disable-next-line
  }, []);

  return (
    <ProductsProvider>
      <ProductItems />
    </ProductsProvider>
  );
};

Products.propTypes = {};

export default Products;